<div class="home">
  <div class="main-content">
    <div nz-row>
      <div nz-col nzSpan="12" class="left-section">
        <div>
          <h1 class="title">
            Driving the NFL's global footprint with governed data, unified insights, and controlled marketing
            activation.
          </h1>

          <p class="description">
            The International Data Portal delivers secure access to international data, powerful analytics, and
            controlled marketing workflows, bringing clarity, consistency, and strategy to the League's worldwide
            growth.
          </p>

          <h1 nz-typography class="desc">Why need us?</h1>

          <nz-steps class="redDots" nzDirection="vertical" nzSize="small" [nzCurrent]="4">
            <nz-step nzTitle="Access all your international audience data in a single portal"> </nz-step>

            <nz-step nzTitle="See who your fans are and where to focus your efforts"> </nz-step>

            <nz-step nzTitle="Market to fans with League-approved data usage"> </nz-step>

            <nz-step nzTitle="Use League data and tools while staying in control of your club campaigns"> </nz-step>
          </nz-steps>
        </div>
      </div>
      <div nz-col nzSpan="12" class="right-section">
        <img nz-image nzSrc="/assets/images/nfl_01-balls-on-field.jpg" alt="NFL" [nzDisablePreview]="true" />
      </div>
    </div>
    <p class="red">What the Platform Delivers</p>
    <p class="blue">
      A unified engine for exploring international markets, understanding fans, and activating brand-safe marketing.
    </p>
  </div>
  <div class="card-container">
    <div class="card" (click)="navigate(card)" *ngFor="let card of cards">
      <div class="icon-wrapper">
        <img width="32" height="32" [src]="card.iconPath" [alt]="card.title" />
      </div>
      <div class="content">
        <h3>{{ card.title }}</h3>
        <p class="card-description">{{ card.description }}</p>
      </div>
    </div>
  </div>
</div>
<div>
  <app-match-schedules></app-match-schedules>
</div>
